import * as PIXI from 'pixi.js'
import { AnimatedGIF } from '@pixi/gif'

/**
 * This plugin enables Pixi loader to handle ObjectURL for loading Textures.
 */
const ObjectUrlLoaderPlugin: PIXI.ILoaderPlugin = {
  async pre (resource: PIXI.LoaderResource, next: () => void): Promise<void> {
    try {
      if (resource.url.startsWith('blob:')) {
        const blob = await getBlobFromObjectUrl(resource.url)
        if (blob.type === 'image/gif') {
          const buffer = await blob.arrayBuffer()
          resource.animation = AnimatedGIF.fromBuffer(buffer)
        } else if (blob.type.startsWith('image')) {
          await loadImageResource(resource)
        } else if (blob.type.startsWith('video')) {
          resource.data = blob
        }
      }
    } catch (e) {
      //Errors can occur while loading an image resources. Eg: Uploading an image with a wrong extension.
      resource.error = e as Error
      resource.complete()
    } finally {
      next()
    }
  }
}

const getBlobFromObjectUrl = async (url: string): Promise<Blob> => {
  return await (await fetch(url)).blob()
}

const loadImageResource = async (resource: PIXI.LoaderResource): Promise<void> => {
  const img = new Image()
  img.src = resource.url
  const imageResource = new PIXI.ImageResource(img, { autoLoad: false })
  const loadedImage = await imageResource.load()
  img.remove()
  if (loadedImage) {
    resource.texture = new PIXI.Texture(new PIXI.BaseTexture(loadedImage))
  } else {
    resource.error = new Error('Error loading image element')
  }
}

export default ObjectUrlLoaderPlugin